export const headerClass = 'header-no-border title-col large-header align-center inline-display';
export const subtitleClass = 'table-header title-col align-right large-header';
export const headerClassRight = 'table-header title-col align-right';
export const contentClass = 'align-right';
export const totalClass = 'title-col division-bottom-only division-top-only subtitle cell ';
export const totalClassAlignRight = `${totalClass} ${contentClass}`;
// +1 for javascript arrays starting at 0, +2 for the 2 title rows
export const OFFSET_TO_STARTING_ROW = 3;
export const FIRM_TOTALS_LABEL = 'Firm Totals';
export const TOTAL_LABEL = 'Total';
export const EXIT_DATE_ALIAS = 'exit_date';
export const EXIT_EQUITY_ALIAS = 'exit_equity_value';
export const EXIT_ENTERPRISE_VALUE_ALIAS = 'exit_enterprise_value';
export const PLUS_CASH_ALIAS = 'plus_cash';
export const LESS_DEBT_ALIAS = 'less_debt';
export const CAP_TABLE_ALIAS = 'cap_table';
export const MEASUREMENT_DATE_ALIAS = 'measurementDateId';
export const COMPANY_ALIAS = 'companyId';
export const FIRM_TOTAL_EXIT_PROCEEDS_ALIAS = 'firm_total_exit_proceeds';

export const defaultWaterfallApiCallParams = {
  scenarioType: 1, // Waterfall should use CURRENT VALUE type
  maturity: '0', // OPM not used for standard waterfall
  volatility: '0', // OPM not used for standard waterfall
  scenarioMethod: 0,
};
